// extracted by mini-css-extract-plugin
export default {"cls1":"Comment-cls1___0764d8facbed41ed66d","cls2":"Comment-cls2__e6ff414e1120ee1671f6 Comment-cls1___0764d8facbed41ed66d"};